<template>
  <div v-show="!state.play" class="headbar">
    <div class="float-left align-left" style="width: 160px;padding-left: 2px;max-width: calc(100vw - 250px);">
      <el-button class="iconfont my-close" @click="emit('goto', ['', '', '', true])" />
    </div>
    <div class="float-left" style="width: calc(100vw - 320px);min-width: 80px;">
      <el-button class="iconfont my-cancel" :disabled="!btnStatus.back" @click="emit('back')" />
      <el-button class="iconfont my-redo" :disabled="!btnStatus.redo" @click="emit('redo')" />
    </div>
    <div class="float-right" style="width: 160px;">
      <span class="color-44">|</span>
      <el-popover v-model="layerPopoverShow" placement="bottom" width="260" popper-class="layer-popover" trigger="click">
        <div class="layer-mng objs-div">
          <div class="my-title-bar">
            <el-col :span="12">
              <div class="margin-top4">
                {{ $t('i.layer') }}
              </div>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-button class="iconfont my-blank-object-add" :title="$t('i.blankObj')" @click="emit('addBlankObj', [false])" />
              <el-button class="iconfont my-object-add" :title="$t('i.openLocalImages')" @click="() => emit('openLocalImages', ['import'])" />
              <el-button class="iconfont my-link-add" :title="$t('i.openWebImage')" @click="() => emit('openWebImage', ['import'])" />
            </el-col>
          </div>
          <div v-if="view.objs" :style="objAreaStyle">
            <div v-for="(obj, idx) in curObjs" :key="obj.id" class="obj-div" :class="getObjClass(obj.id, '')">
              <div class="obj-img" :style="{ background: 'url(' + bgImg4 + ')' }" @click="(event) => emit('select', [obj.id, '', idx, -1, event.shiftKey])">
                <obj-preview
                  :key="'obj-preview:' + state.sceneId + ':' + obj.id"
                  :state="state"
                  :file-type="file.type"
                  :idx="idx"
                  :obj="obj"
                />
              </div>
              <div class="obj-info padding-left4">
                <div><edit-text :val="obj.name" :title="$t('i.editObjName')" @receive="(val) => (obj.name = val)" /></div>
                <div class="color-99" @click="(event) => emit('select', [obj.id, '', idx, -1, event.shiftKey])">{{ obj.cols }} x {{ obj.rows }}</div>
              </div>
              <div class="obj-btn">
                <el-button v-if="obj.show" class="iconfont my-eye-open" :title="$t('i.hide')" @click="emit('show', [idx])" />
                <el-button v-if="!obj.show" class="iconfont my-eye-close" :title="$t('i.show')" @click="emit('show', [idx])" />
                <el-dropdown trigger="click" placement="bottom-start" size="medium" @command="(e) => emit('handle', [e, [idx]])">
                  <el-button class="iconfont my-dot-more-v" :title="$t('i.more')" @click="(event) => emit('select', [obj.id, '', idx, -1, event.shiftKey])" />
                  <el-dropdown-menu slot="dropdown" class="my-dropdown">
                    <el-dropdown-item v-if="!obj.lock" command="lockSelectObjs" class="iconfont my-lock"> {{ $t('i.lock') }}</el-dropdown-item>
                    <el-dropdown-item v-if="obj.lock" command="unlockSelectObjs" class="iconfont my-unlock"> {{ $t('i.unlock') }}</el-dropdown-item>
                    <el-dropdown-item :disabled="!btnStatus.copy" command="copyAndParse" class="iconfont my-copyparse"> {{ $t('i.copyparse') }}</el-dropdown-item>
                    <el-dropdown-item :disabled="!btnStatus.del" command="del" class="iconfont my-delete"> {{ $t('i.delete') }}</el-dropdown-item>
                    <el-dropdown-item :disabled="!btnStatus.clear" command="clear" class="iconfont my-clear"> {{ $t('i.clear') }}</el-dropdown-item>
                    <el-dropdown-item :disabled="!btnStatus.restore" command="restore" class="iconfont my-restore"> {{ $t('i.restore') }}</el-dropdown-item>
                    <el-dropdown-item v-if="idx < curObjs.length - 1" command="mergeDown" :disabled="!btnStatus.mergeDown" class="iconfont my-mergedown"> {{ $t('i.mergeDown') }}</el-dropdown-item>
                    <el-dropdown-item v-if="idx < curObjs.length - 1" command="layDown" :disabled="!btnStatus.layDown" class="iconfont my-lay-down"> {{ $t('i.layDown') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="obj-div">
              <div class="obj-img">
                <canvas ref="canvasGrid" />
              </div>
              <div class="obj-info padding-top12 padding-left4">
                {{ $t('i.grid') }}
              </div>
              <div class="obj-btn">
                <el-button v-if="canvas.showGrid" class="iconfont my-eye-open" :title="$t('i.hide')" @click="emit('setCanvasAttr', ['showGrid', false])" />
                <el-button v-if="!canvas.showGrid" class="iconfont my-eye-close" :title="$t('i.show')" @click="emit('setCanvasAttr', ['showGrid', true])" />
                <el-button class="iconfont" :style="{'background': canvas.gridColor + '!important', 'border': '1px solid #444!important'}" @click="(event) => {emit('toggleColorPicker', [event, 'canvas-gridcolor'])}" />
              </div>
            </div>
            <div class="obj-div">
              <div class="obj-img">
                <div class="box40" :style="{'background': canvas.bgColor}" />
              </div>
              <div class="obj-info padding-top12 padding-left4">
                {{ $t('i.bg') }}
              </div>
              <div class="obj-btn">
                <el-button v-if="canvas.showBg" class="iconfont my-eye-open" :title="$t('i.hide')" @click="emit('setCanvasAttr', ['showBg', false])" />
                <el-button v-if="!canvas.showBg" class="iconfont my-eye-close" :title="$t('i.show')" @click="emit('setCanvasAttr', ['showBg', true])" />
                <el-button class="iconfont" :style="{'background': canvas.bgColor + '!important', 'border': '1px solid #444!important'}" @click="(event) => {emit('toggleColorPicker', [event, 'canvas-bgcolor'])}" />
              </div>
            </div>
          </div>
        </div>
        <el-button slot="reference" class="iconfont my-lay-bottom" />
      </el-popover>
      <el-popover v-model="setPopoverShow" placement="bottom" width="290" trigger="click">
        <el-row>
          <el-col :span="8" class="size12">{{ $t('i.createTime') }}</el-col>
          <el-col :span="16" class="align-right color-99 size12">{{ file.createTime }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="size12">{{ $t('i.canvaSizes') }}</el-col>
          <el-col :span="16" class="align-right color-99 size12">{{ canvas.cols + ' x ' + canvas.rows }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="size12">{{ $t('i.consumeTime') }}</el-col>
          <el-col :span="16" class="align-right color-99 size12">{{ consumeTime() }}</el-col>
        </el-row>
        <el-row class="popover-set-btns">
          <el-col :span="6"><el-button class="iconfont my-full-canvas" @click="emit('autoCanvasSize')" /><div class="size10">{{ $t('i.fixCanvas') }}</div></el-col>
          <el-col :span="6"><el-button class="iconfont my-canvas" @click="emit('openSetCanvasSize')" /><div class="size10">{{ $t('i.setCanvas') }}</div></el-col>
          <el-col :span="6"><el-button class="iconfont my-bar-left" :class="{'blue': !view.rightToolBar}" @click="view.rightToolBar = false" /><div class="size10">{{ $t('i.leftBar') }}</div></el-col>
          <el-col :span="6"><el-button class="iconfont my-bar-right" :class="{'blue': view.rightToolBar}" @click="view.rightToolBar = true" /><div class="size10">{{ $t('i.rightBar') }}</div></el-col>
        </el-row>
        <el-button slot="reference" class="iconfont my-set-up" />
      </el-popover>
      <el-button class="iconfont my-material" @click="emit('openDraft', ['draft'])" />
      <el-dropdown trigger="click" placement="bottom-start" @command="(e) => selectOpt(e)">
        <el-button class="iconfont my-out" />
        <el-dropdown-menu slot="dropdown" class="my-dropdown">
          <el-dropdown-item command="openCreateNewFile"> <i class="iconfont my-file" /> {{ $t('i.newFile') }}</el-dropdown-item>
          <el-dropdown-item command="openFile"> <i class="iconfont my-file" /> {{ $t('i.openFile') }}</el-dropdown-item>
          <el-dropdown-item command="save"> <i class="iconfont my-save-as" /> {{ $t('i.save') }}</el-dropdown-item>
          <el-dropdown-item command="saveAs"> <i class="iconfont my-save-as" /> {{ $t('i.saveAs') }}</el-dropdown-item>
          <el-dropdown-item command="saveRemote"> <i class="iconfont my-cloud-sync" /> {{ $t('i.cloudSync') }}</el-dropdown-item>
          <el-dropdown-item command="rename"> <i class="iconfont my-rename" /> {{ $t('i.rename') }}</el-dropdown-item>
          <el-dropdown-item command="exportPixel" divided> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportPixel') }}</div></el-dropdown-item>
          <el-dropdown-item command="exportGridy"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportGridy') }}</div></el-dropdown-item>
          <el-dropdown-item command="exportBrick"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportPuzzle') }}</div></el-dropdown-item>
          <el-dropdown-item command="exportPreview"> <div class="padding-top4 padding-bottom4"><i class="iconfont my-export-out" />{{ $t('i.exportPreview') }}...</div></el-dropdown-item>
          <el-dropdown-item command="diyBrick" divided> <div class="padding-top4 padding-bottom4"><i class="iconfont my-diy" />{{ $t('i.createPuzzle') }}...</div></el-dropdown-item>
          <!-- <el-dropdown-item command="openMywork" divided> <div class="padding-top4 padding-bottom4"><i class="iconfont my-pixel" /> {{ $t('i.myWorks') }}</div></el-dropdown-item> -->
          <!-- <el-dropdown-item command="openAiPaint" divided> <div class="padding-top4 padding-bottom4"><i class="iconfont my-ai-paint" /> {{ $t('i.aiart') }}</div></el-dropdown-item> -->
          <el-dropdown-item command="publishWork" divided> <i class="iconfont my-zone" /> {{ $t('i.publish') }}...</el-dropdown-item>
          <el-dropdown-item command="copyShareUrl"> <i class="iconfont my-share-out" /> {{ $t('i.copyLink') }}</el-dropdown-item>
          <el-dropdown-item command="createPOP"> <i class="iconfont my-pop" /> {{ $t('i.createShareImage') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mixins } from '@/mixins/common'
import utils from '@/js/utils'
import editText from '@/components/editText'
import objPreview from '@/components/objPreview'
import bgImg4 from '@/assets/canvas_bg/bg_4.png'
export default {
  components: {
    editText,
    objPreview
  },
  mixins: [mixins],
  props: {
    btnStatus: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return { setPopoverShow: false, layerPopoverShow: false, bgImg4: bgImg4 }
  },
  computed: {
    // 对象区域样式
    objAreaStyle() {
      let factor = 1
      if (!this.isDesktop) {
        factor = 2
      }
      const rows = this.curObjs.length + 2
      return { width: '100%', height: (rows < 3 * factor ? rows * 52 : 156 * factor) + 'px', 'overflow-x': 'hidden', 'overflow-y': 'auto' }
    },
    // 画布背景颜色
    canvasBgColor() {
      return this.canvas.showBg ? this.canvas.bgColor : ''
    },
    // 网格边框颜色
    gridColor() {
      return this.canvas.showGrid ? this.canvas.gridColor : ''
    }
  },
  watch: {
    'file.canvas.gridColor': {
      handler(val) {
        this.drawCanvasGrid()
      }
    }
  },
  methods: {
    selectOpt(act) {
      if (act === 'exportPixel' || act === 'exportGridy' || act === 'exportBrick' || act === 'exportAdvance') {
        const opts = { gridSize: this.state.gridSize, brickfy: this.state.brickfy }
        if (act === 'exportBrick') {
          opts.workTypeid = 2
          opts.paletteId = 'brickfy'
          opts.brickfy = true
        }
        this.emit('showExportSheet', [this.file, act, opts, this.state.sceneIdx])
      } else if (act === 'openMywork') {
        this.emit('openResource', ['work'])
      } else if (act === 'openAiPaint') {
        this.emit('openResource', ['paint'])
      } else if (act === 'diyBrick') {
        this.emit('diy', ['brick'])
      } else if (act === 'openFile') {
        this.emit('showOpenSheet')
      } else {
        this.emit(act, [])
      }
    },
    consumeTime() {
      return utils.getCountDown((new Date() - new Date(this.file.createTime)) / 1000)
    },
    // 绘制网格
    drawCanvasGrid() {
      const canvasGrid = this.$refs.canvasGrid
      if (!canvasGrid) return
      const canvasGridCtx = canvasGrid.getContext('2d')
      canvasGrid.width = 41
      canvasGrid.height = 41
      canvasGridCtx.clearRect(0, 0, canvasGrid.width, canvasGrid.height)
      canvasGridCtx.fillStyle = this.canvas.gridColor || '#242424'
      canvasGridCtx.fillRect(0, 0, canvasGrid.width, canvasGrid.height)
      let x
      let y
      const gridSize = 5
      for (x = 0; x < 8; x++) {
        for (y = 0; y < 8; y++) {
          canvasGridCtx.clearRect(x * gridSize + 1, y * gridSize + 1, gridSize - 1, gridSize - 1)
        }
      }
    },
    // 获取对象样式Class
    getObjClass(id, parentId) {
      let k
      if (parentId) {
        k = 'sub-obj:' + this.state.sceneId + ':' + parentId + ':' + id
      } else {
        k = 'obj:' + this.state.sceneId + ':' + id
      }
      return this.state.selectObjs[k] ? 'select' : ''
    }
  }
}
</script>
